import React from 'react'
import styled, { DefaultTheme } from 'styled-components'
import { SmallCurrencyLogo } from '../CurrencyLogo' 
import { coinImage } from '../../assets/coins/coins'
import { MouseoverTooltip } from './ToolTip'
import { SmallInformation } from "./Information"

const RewardsStyle = styled.div`
  display:flex;
  align-items:center;
  justify-content:center;
  color: ${({ theme }) => theme.rewardsColor};
  background: ${({ theme }) => theme.rewardsBackgroundColor};
  border: 1px solid ${({ theme }) => theme.rewardsBorderColor};
  border-radius:14px;
  padding:0.5rem;
  cursor:pointer;
  font-size:1.4rem;
  opacity: 0.9;
`

export interface ChildrenProps {
    children: React.ReactNode
}

export function NetAPR(props: ChildrenProps) {
  return <MouseoverWrapper children={props.children} legend={"This is the pool's annualized yield since its inception, net of any cost (IL, etc.). Token incentives are not taken into account and should be added on-top."}/>
}

export function Past24hVolume(props: ChildrenProps) {
  return <MouseoverWrapper children={props.children} legend={"This is the past 24h trading volume in $."}/>
}

export interface MouseoverProps {
  children: React.ReactNode
  legend: React.ReactNode
}

export function MouseoverWrapper(props: MouseoverProps) {
  return (
    <div>
      <MouseoverTooltip
        text={
          <div 
            style={{
                display:'flex',
                flexDirection:'column',
                textAlign:'left',
                cursor:'text',
                fontFamily:'Montserrat-Light',
                fontWeight:'normal'
            }}
          >
            <span>{props.legend}</span>
          </div>
        }
        disableHover={false}
        show={false}
      >
        <div style={{display:'flex',verticalAlign:'middle',alignItems:'center',cursor:'pointer'}}>{props.children}<SmallInformation /></div>
      </MouseoverTooltip>
    </div>
  )
}